/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPSWITCHTYPE = {
    RegularSwitch: 'REG_SWI'
} as const;
export type IAPSWITCHTYPE = typeof IAPSWITCHTYPE[keyof typeof IAPSWITCHTYPE];


export function IAPSWITCHTYPEFromJSON(json: any): IAPSWITCHTYPE {
    return IAPSWITCHTYPEFromJSONTyped(json, false);
}

export function IAPSWITCHTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPSWITCHTYPE {
    return json as IAPSWITCHTYPE;
}

export function IAPSWITCHTYPEToJSON(value?: IAPSWITCHTYPE | null): any {
    return value as any;
}

